// @ts-ignore
import content from './md/how-estimate-signing-works.md';

export const meta = {
  slug: 'how-estimate-signing-works',
  title: 'How Estimate Signing Works (And Why It Matters for Customers)',
  excerpt: 'Estimate signing helps customers approve work quickly with full visibility. Learn what it includes, why it matters, and what to expect after signing.',
  date: 'February 2026',
  readTime: '6 min read'
};

export { content };
